<div class="table-overflow" cdkScrollable>
  <div class="table-overflow-inner">
    <ng-content></ng-content>
  </div>
</div>
